/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

const ResponseCodesEnum = {
  UNAUTHORIZED: 401,
  ERR_BAD_REQUEST: 400,
};

export default ResponseCodesEnum;
